import { toggleable } from '../Checkbox'

export const Radio = toggleable({
  borderRadius: '50%',
  symbolIcon: 'radio',
})
